import { render } from "./ProductRanking.vue?vue&type=template&id=78966b62&scoped=true"
import script from "./ProductRanking.vue?vue&type=script&lang=js"
export * from "./ProductRanking.vue?vue&type=script&lang=js"

import "./ProductRanking.vue?vue&type=style&index=0&id=78966b62&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78966b62"]])

export default __exports__